import { useCallback, useMemo } from "react";
import { useAppSelector, useAppDispatch } from "../../../../../redux/store";
import {
  TextField,
  Select,
  MenuItem,
  Box,
  FormControl,
  InputLabel,
  Chip,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid";

import {
  handleCustomerChange,
  handleBusinessChange,
} from "../../../../../redux/slices/customersSlice";

const companyOptions = ["Business 1", "Business 2", "Business 3"];

const Info = () => {
  const {
    selectedCustomer,
    changes,
    updateCustomerStatus,
    createCustomerStatus,
    fetchCustomerStatus,
    deleteCustomerStatus,
  } = useAppSelector((state) => state.customers);
  const dispatch = useAppDispatch();

  const handleChange = useCallback(
    (e: any) => {
      const { name, value } = e.target;
      dispatch(handleCustomerChange({ name, value }));
    },
    [dispatch]
  );

  const onBusinessChange = useCallback(
    (e: any) => {
      dispatch(handleBusinessChange(e.target.value));
    },
    [dispatch]
  );

  const isLoading = useMemo(() => {
    return (
      updateCustomerStatus === "loading" ||
      createCustomerStatus === "loading" ||
      fetchCustomerStatus === "loading" ||
      deleteCustomerStatus === "loading"
    );
  }, [
    updateCustomerStatus,
    createCustomerStatus,
    fetchCustomerStatus,
    deleteCustomerStatus,
  ]);

  return (
    <>
      <Divider sx={{ mb: 2 }} textAlign="left">
        Personal Information
      </Divider>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <TextField
            type="text"
            fullWidth
            size="small"
            label="Name"
            name="name"
            value={
              changes?.firstName === undefined
                ? selectedCustomer?.name || ""
                : changes?.name
            }
            onChange={handleChange}
            disabled={isLoading}
          />
        </Grid>
      </Grid>
      <Divider sx={{ mt: 3, mb: 2 }} textAlign="left">
        Contact Information
      </Divider>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            type="email"
            fullWidth
            size="small"
            label="Email"
            name="email"
            value={
              changes?.email === undefined
                ? selectedCustomer?.email || ""
                : changes?.email
            }
            onChange={handleChange}
            disabled={isLoading}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            type="tel"
            fullWidth
            size="small"
            label="Phone"
            name="phone"
            value={
              changes?.phone === undefined
                ? selectedCustomer?.phone || ""
                : changes?.phone
            }
            onChange={handleChange}
            disabled={isLoading}
          />
        </Grid>
      </Grid>
      <Divider sx={{ mt: 3, mb: 2 }} textAlign="left">
        Business/Banking Information
      </Divider>
      <Grid container spacing={2}>
        {/* <Grid size={{ xs: 12 }}>
          <TextField
            type="number"
            fullWidth
            size="small"
            label="Bank Account"
            name="bankAccount"
            value={
              changes?.bankAccount === undefined
                ? selectedCustomer?.bankAccount || ""
                : changes?.bankAccount
            }
            onChange={handleChange}
            disabled={isLoading}
          />
        </Grid> */}

        <Grid size={{ xs: 12 }}>
          <FormControl fullWidth size="small">
            <InputLabel>Company Name</InputLabel>
            <Select
              disabled={isLoading}
              multiple
              value={
                changes?.doingBusinessWith ||
                selectedCustomer?.doingBusinessWith ||
                []
              }
              label="Business Name"
              onChange={onBusinessChange}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value: any) => (
                    <Chip key={value} size="small" label={value} />
                  ))}
                </Box>
              )}
            >
              {companyOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};

export default Info;
